import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2ActivityIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 47.005 47",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47.005),
    children: /*#__PURE__*/jsx("path", {
      d: "M44.758 29.24L29.508 44.5l-7.5 1.5 1.5-7.5L38.77 23.24a4.226 4.226 0 015.982 0l.018.016a4.232 4.232 0 01-.012 5.984zM16 40H4a3 3 0 01-3-3V4a3 3 0 013-3h30a3 3 0 013 3v13.5M16 10h12M10 19h18M10 28h15"
    })
  });
};

export { PM2ActivityIcon };
//# sourceMappingURL=activity.js.map
